// React bootstrap table next =>
// DOCS: https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/
// STORYBOOK: https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import React, { useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";

import * as uiHelpers from "../CityUIHelpers";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
} from "../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../_metronic/_partials/controls";
import { useCityUIContext } from "../CityUIContext";

export function CityTable({
  isLoading,
  cityList,
  cityListTotalCount,
  currentPage,
  setCurrentPage,
}) {
  // City UI Context
  const cityUIContext = useCityUIContext();
  const cityUIProps = useMemo(() => {
    return {
      ids: cityUIContext.ids,
      setIds: cityUIContext.setIds,
      queryParams: cityUIContext.queryParams,
      setQueryParams: cityUIContext.setQueryParams,
      openReceiptDialog: cityUIContext.openReceiptDialog,
      openDeleteDialog: cityUIContext.openDeleteDialog,
      openEditDialog: cityUIContext.openEditDialog,
    };
  }, [cityUIContext]);

  // Table columns
  const columns = [
    // {
    //   dataField: "id",
    //   text: "ID",
    //   sort: true,
    //   sortCaret: sortCaret,
    //   style: {
    //     minWidth: "110px",
    //   },
    // },
    {
      dataField: "name",
      text: "CITY",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "110px",
      },
      formatter: columnFormatters.CityNameColumnFormatter,
    },
    {
      dataField: "state_id",
      text: "STATE	",
      formatter: columnFormatters.StateTypeFormatter,
      style: {
        minWidth: "110px",
      },
    },
    {
      dataField: "status",
      text: "STATUS",
      formatter: columnFormatters.StatusTypeFormatter,
      style: {
        minWidth: "110px",
      },
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openReceiptDialog: cityUIProps.openReceiptDialog,
        openDeleteDialog: cityUIProps.openDeleteDialog,
        openEditDialog: cityUIProps.openEditDialog,
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "80px",
      },
    },
  ];
  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: cityListTotalCount ? cityListTotalCount : 0,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: cityUIProps.queryParams.pageSize,
    page: currentPage,
    onPageChange: (page) => {
      if (page === 0) return;
      setCurrentPage(page);
    },
  };
  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination isLoading={isLoading} paginationProps={paginationProps}>
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-head-bg table-borderless table-vertical-center city-table"
                bootstrap4
                bordered={false}
                remote
                keyField="id"
                data={cityList ? cityList : []}
                columns={columns}
                defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  cityUIProps.setQueryParams
                )}
                {...paginationTableProps}
              ></BootstrapTable>
              <PleaseWaitMessage isLoading={isLoading} />
              <NoRecordsFoundMessage
                entities={cityList}
                errorMessage={"No cities found!"}
              />
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
}
